"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var APIGroupIcon = function APIGroupIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.514 1.126a1 1 0 0 1 .972 0l9 5A1 1 0 0 1 22 7v10a1 1 0 0 1-.514.874l-9 5a1 1 0 0 1-.972 0l-9-5A1 1 0 0 1 2 17V7a1 1 0 0 1 .514-.874l9-5zM4 7.588v8.824l8 4.444 8-4.444V7.588l-8-4.444-8 4.444z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.514 5.626a1 1 0 0 1 .972 0l5 2.78A1 1 0 0 1 18 9.28V15a1 1 0 1 1-2 0V9.868l-4-2.224-4 2.224V15a1 1 0 1 1-2 0V9.28a1 1 0 0 1 .514-.874l5-2.78z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9.5a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1zm0 4.5a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1z"
  }));
};
APIGroupIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#APIGroupAsset',
    assetType: 'APIGroup'
  },
  owner: {
    gusTeam: 'TBD'
  },
  name: 'API Group',
  publication: {
    versioningAllowance: 'major',
    inferredBy: [{
      typeProperty: 'api-group'
    }],
    minimumInputSets: [{
      files: [],
      requiredProperties: ['apiGroupVersion']
    }],
    customProperties: [{
      name: 'apiGroupVersion',
      storeAsAttribute: true
    }],
    dependenciesRestrictions: {
      minimum: 1,
      permissionLevel: 'admin',
      allowedTypes: ['rest-api', 'http-api', 'soap-api']
    }
  },
  portal: {
    icon: APIGroupIcon,
    color: '#9a63f9' // violet3
  },
  visibility: 'public',
  keywords: ['group', 'api']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map